import { Component, OnInit, Input, AfterViewInit } from '@angular/core'
import { ChartModel } from './chart.model'
import { ChartService } from './chart.service'
import { PageService } from '../../page/page.service'
import { AjaxService } from 'src/app/shared/ajax.service'

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html'
})

export class ChartComponent implements OnInit {
  @Input() model: ChartModel
  @Input() ido: string
  @Input() dyn: any
  ctyp = 'chart'
  canvas: any
  ctx: any

  constructor(private pservice: PageService, private service: ChartService, private ajax: AjaxService) {
    service.components = this.pservice.components.charts
  }

  ngOnInit() {
    this.pservice.components.charts.push({ service: this.service, model: this.model })
    if (this.ido) {
      this.model = new ChartModel()
      this.model.id = this.ido
    }
  }

  ngAfterViewInit() {
    if (this.ido)
      this.ajax.execute({
        url: 'chart/charts',
        data: { id: this.ido },
        success: (post) => {
          this.model = post.result[0]
          this.service.modifier(this.model)
          this.service.init(this.model)
        }
      })
    else
      this.service.init(this.model)
  }
}